export enum CourseInviteStatus {
  new = "new",
}
